import { useContext } from 'react';

import { PresetsContext } from 'components/Presets/PresetsContext';
import {
  update,
  grid,
  groupedPresets,
} from 'components/Presets/data/queryKeyFactory';
import { editPreset } from 'components/Presets/sources/presets';

import { useMutation, useQueryClient } from '@gogame/query';

export const useSharePreset = () => {
  const queryClient = useQueryClient();
  const { grouped } = useContext(PresetsContext);

  const updateMutation = useMutation(update(), editPreset, {
    successMessage: (data) =>
      data.isPublic
        ? 'Preset was shared. All changes that you make to your preset will be available for all users.'
        : 'Preset was unshared. Other users can no longer use it.',
    onMutate: async (changedPreset) => {
      try {
        queryClient.setQueriesData(
          { queryKey: grouped ? groupedPresets({}) : grid({}), exact: false },
          (previousPresets) => {
            if (grouped) {
              return {
                ...previousPresets,
                my: previousPresets?.my.map((group) => ({
                  ...group,
                  children: group.children.map((preset) =>
                    preset.id === changedPreset.id ? changedPreset : preset
                  ),
                })),
              };
            } else {
              return previousPresets?.map((preset) => {
                if (preset.id === changedPreset.id) {
                  return changedPreset;
                }
                return preset;
              });
            }
          }
        );
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('share preset', e);
      }
    },
  });

  return [updateMutation.mutateAsync, updateMutation];
};
